
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 329 329"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M194.6 164.8L322.7 36.7c8.3-8.3 8.3-21.8 0-30.1s-21.8-8.3-30.1 0l-128.1 128L36.4 6.5c-8.3-8.3-21.8-8.3-30.1 0s-8.3 21.8 0 30.1l128.1 128.1L6.3 292.9c-8.3 8.3-8.3 21.8 0 30.1 4.2 4.2 9.6 6.2 15.1 6.2s10.9-2.1 15.1-6.2l128.1-128.1 128 128.1c4.2 4.2 9.6 6.2 15.1 6.2s10.9-2.1 15.1-6.2c8.3-8.3 8.3-21.8 0-30.1L194.6 164.8z","opacity":".75","fill":"#8f9aaa"}})])
          )
        }
      }
    